import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBerichten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M33 11.25H5v11.38h28z"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M5 11.25 19 20l14-8.75v17.5H5z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m16.32 20.82-5.45-3.4.53-.85 4.92 3.07 10.28-6.42.53.85z"
    />
    <path
      fill="#FF5151"
      d="M28.06 35.06a6.94 6.94 0 1 0 0-13.88 6.94 6.94 0 0 0 0 13.88"
    />
    <path
      fill="#fff"
      d="M26.99 23.64h2.12l-.36 5.92h-1.4zm1.06 9.13c-.3 0-.56-.1-.76-.31s-.31-.46-.31-.75.11-.56.32-.77.46-.32.76-.32.55.11.76.32.32.47.32.77-.1.54-.31.75-.46.31-.76.31z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBerichten);

export default ForwardRef;
